import ReactDOM from 'react-dom';
import { compose, lifecycle } from 'recompose';

import setWrappedDisplayName from './setWrappedDisplayName';

function scrollComponent () {
    ReactDOM.findDOMNode(this).scrollIntoViewIfNeeded();
}

export default compose(
    setWrappedDisplayName('scrollComponentIntoView'),
    lifecycle({
        componentDidMount: scrollComponent,
        componentDidUpdate: scrollComponent
    })
);



// WEBPACK FOOTER //
// ./src/helpers/scrollComponentIntoView.js